import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomePage.vue'
import Search from '../views/SearchPage.vue'
import Contact from '../views/ContactPage.vue'
import Support from '../views/SupportPage.vue'
import PrivacyPage from '../views/PrivacyPage.vue'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/search', name: 'Search', component: Search },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/support', name: 'Support', component: Support },
  { path: '/streams', name: 'Streams', component: () => import('@/views/Streamspage.vue') },
  { path: '/mobileapps', name: 'MobileApps', component: () => import('@/views/Mobileappspage.vue') },
  { path: '/album/:albumid', name: 'AlbumPage', component: () => import('@/views/AlbumPage.vue') },
  { path: '/artist/:artistid', name: 'ArtistPage', component: () => import('@/views/ArtistPage.vue') },
  { path: '/composer/:composerid', name: 'ComposerPage', component: () => import('@/views/ComposerPage.vue') },
  { path: '/newadditions', name: 'NewAdditions', component: () => import('@/views/Newadditions.vue') },
  { path: '/privacy', name: 'Privacy', component: PrivacyPage },
  { path: '/recenttracks', name: 'RecentTracks', component: () => import('@/views/RecentTracks.vue') },
  { path: '/listen', name: 'Listen', component: () => import('@/views/ListenPage.vue') }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
